// extracted by mini-css-extract-plugin
export default {"root":"GroupContestSummary_root__jM8D0"};